<template>
  <v-menu
    :close-on-content-click="closeOnContentClick"
    :nudge-right="40"
    :disabled="readonly"
    transition="scale-transition"
    offset-y
    max-width="290px"
    v-model="menu"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        :hint="hint"
        prepend-icon="event"
        persistent-hint
        hide-details
        :readonly="readonly"
        v-on="on"
        :disabled="disabled"
        @blur="input(parseDate($event.target.value), false)"
        :error-messages="validator ? $errors(validator) : []"
        :rules="rules"
      />
    </template>
    <v-date-picker
      :active-picker.sync="activePicker"
      :type="type"
      :color="color"
      no-title
      :value="localValue"
      @input="input"
      @change="change"
      :locale="locale"
      :first-day-of-week="firstDayOfWeek"
      :max="max"
    >
      <v-spacer />
    </v-date-picker>
  </v-menu>
</template>

<script>
import i18n from '@/utils/i18n'
import { parseDate } from '@/utils/date'

export default {
  props: {
    type: String,
    value: String,
    label: String,
    color: String,
    hint: String,
    dateFormatter: Function,
    closeOnContentClick: {
      type: Boolean,
      default: true,
    },
    firstDayOfWeek: {
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    max: String,
    startByYear: {
      type: Boolean,
      default: false,
    },
    validator: Object,
    rules: Array,
  },
  data() {
    return {
      menu: false,
      localValue: this.value,
      dateFormatted: this.formatDate(this.value),
      activePicker: null,
    }
  },
  watch: {
    value(val) {
      this.localValue = val
    },
    localValue(val) {
      this.dateFormatted = this.formatDate(val)
    },
    menu(val) {
      val &&
        this.$nextTick(() => {
          if (this.startByYear) {
            this.activePicker = 'YEAR'
          }
        })
    },
  },
  computed: {
    locale() {
      return i18n.localeWithDash().toLowerCase()
    },
  },
  methods: {
    input(event, closeMenu = true) {
      if (closeMenu) {
        this.menu = false
      }
      this.localValue = event
      this.$emit('input', event)
    },
    change(event, closeMenu = true) {
      if (closeMenu) {
        this.menu = false
      }
      this.localValue = event
      this.$emit('change', event)
    },
    formatDate(date) {
      return this.dateFormatter !== undefined &&
        date !== undefined &&
        date !== null
        ? this.dateFormatter(date)
        : date
    },
    parseDate(date) {
      return this.dateFormatter
        ? parseDate(date, this.dateFormatter)
        : this.localValue
    },
  },
}
</script>
